import { ThemeModule } from './../@theme/theme.module';
import { AuthDetailComponent } from './autorizzazioni/auth-detail/auth-detail.component';
import { FormsModule } from '@angular/forms';
import { MultilangRichTextStringWidget } from './multilangrichtext/multilangrichtext-string.widget';
import { AlertInfoAppComponent } from './alert-info-app/alert-info-app-component';
import { EditComponent } from './edit-component/edit.component';
import { AlertModalComponent } from './alert-modal/alert-modal.component';
import { WizardWidget } from './wizard/wizard.widget';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { MultilangStringWidget } from './multilang/multilang-string.widget';
import { NgModule, LOCALE_ID } from '@angular/core';
import { SchemaFormModule, WidgetRegistry, DefaultWidgetRegistry } from 'ngx-schema-form';
import { NgPipesModule } from 'ngx-pipes';
// import { AgmCoreModule } from '@agm/core';
import { StrutturaDetailComponent } from './strutture/struttura-detail/struttura-detail.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgbDatepickerI18n, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerI18n } from './customdatepickerI18n/customdatepickerI18n';
import { MODULES_NB } from '@hm_app/@core/utils/nb_modules';
import { InformativaComponent } from './informativa/informativa.component';
import { LosaicheComponent } from './faqs/losaiche/losaiche.component';
import { GerarchiaFaqComponent } from './faqs/gerarchia-faq/gerarchia-faq.component';
import { FaqComponent } from './faqs/faq/faq.component';
import { StruttureComponent } from './strutture/strutture.component';
import { StruttureRiferimentoComponent } from './strutture/strutture-riferimento/strutture-riferimento.component';
import { TutteStruttureComponent } from './strutture/tutte-strutture/tutte-strutture.component';
import { RicercaFaqComponent } from './faqs/ricerca-faq/ricerca-faq.component';
import { GlossarioFaqComponent } from './faqs/glossario-faq/glossario-faq.component';
import { FaqPerParolaChiaveComponent } from './faqs/faq-per-parola-chiave/faq-per-parola-chiave.component';
import { FaqDetailComponent } from './faqs/faq-detail/faq-detail.component';
import { GenericTableComponent, ButtonViewComponent } from './custom-smart-table/generic-table.component';
import { ListaGravidanzeComponent } from './lista-gravidanze/lista-gravidanze.component';
import { RouterModule } from '@angular/router';
import { environment } from '@src/environments/environment';
import { TinyMCEWidget } from '@hm_app/shared/ng2-sftiny-mce';
import { BaseAuthenticatedComponent } from './base-authenticated/base-authenticated.component';
import { BaseHmComponent } from './base-hm/base-hm.component';
import { AutorizzazioniComponent } from './autorizzazioni/autorizzazioni.component';
import { ChangeAuthComponent } from './autorizzazioni/change-auth/change-auth.component';
import { RuoloUtentePipe } from './ruolo-utente.pipe';
import { VerificaMedicoComponent } from './autorizzazioni/verifica-medico/verifica-medico.component';
import { AssistenzaFaqOperatoriComponent } from './assistenza-faq-operatori/assistenza-faq-operatori.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { NbAccordionModule, NbToastrService } from '@nebular/theme';
import { NtfFormlyModule } from '@hm_app/ntf-formly/ntf-formly.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AbstractListComponent } from './abstract-list/abstract-list.component';
import { InfoComponent } from './info/info.component';
import { InfoAlertComponent } from './info/info-alert/info-alert.component';
import { ListaCorsiGruppiUtenteComponent } from './lista-corsi-gruppi-utente/lista-corsi-gruppi-utente.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { InserisciDataAlertComponent } from './inserisci-data-alert/inserisci-data-alert.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { HmHeaderComponent } from './hm-header/hm-header.component';
import { DashboardOstetricaComponent } from './dashboard-ostetrica/dashboard-ostetrica.component';
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({
  imports: [
    ...MODULES_NB,
    ThemeModule,
    RouterModule,
    FormsModule,
    Ng2SmartTableModule,
    SchemaFormModule,
    NgbDropdownModule,
    NgPipesModule,
    NgbModule,
    // AgmCoreModule.forRoot({ apiKey: environment.google_maps_api_key, }),
    GoogleMapsModule,
    YouTubePlayerModule,
    NgxDatatableModule,
    NtfFormlyModule,
    EditorModule,
    NgxSpinnerModule,
    NgxEchartsModule
  ],
  declarations: [
    MultilangStringWidget,
    MultilangRichTextStringWidget,
    WizardWidget,
    InformativaComponent,
    AlertModalComponent,
    AlertInfoAppComponent,
    EditComponent,
    StrutturaDetailComponent,
    DashboardComponent,

    LosaicheComponent,
    GerarchiaFaqComponent,
    FaqComponent,
    FaqDetailComponent,
    StruttureComponent,
    StruttureRiferimentoComponent,
    TutteStruttureComponent,
    RicercaFaqComponent,
    GlossarioFaqComponent,
    FaqPerParolaChiaveComponent,

    GenericTableComponent,
    ButtonViewComponent,
    ListaGravidanzeComponent,
    BaseAuthenticatedComponent,
    BaseHmComponent,


    AutorizzazioniComponent,
    AuthDetailComponent,
    ChangeAuthComponent,

    RuoloUtentePipe,

    VerificaMedicoComponent,
    AssistenzaFaqOperatoriComponent,
    AbstractListComponent,
    InfoComponent,
    InfoAlertComponent,
    ListaCorsiGruppiUtenteComponent,
    InserisciDataAlertComponent,

    HmHeaderComponent,

    DashboardOstetricaComponent
  ],
  providers: [{ provide: WidgetRegistry, useClass: DefaultWidgetRegistry },
  { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
  {
    provide: LOCALE_ID,
    useValue: 'it',
  },
  ],
  entryComponents: [
    MultilangStringWidget,
    MultilangRichTextStringWidget,
    WizardWidget,
    RicercaFaqComponent,
    GlossarioFaqComponent,
    FaqPerParolaChiaveComponent,
    FaqDetailComponent,
    ListaGravidanzeComponent,
    ButtonViewComponent,
    InformativaComponent,
    AutorizzazioniComponent,
    AuthDetailComponent,
    ChangeAuthComponent,
    VerificaMedicoComponent,
    AssistenzaFaqOperatoriComponent,
    AbstractListComponent,
    InserisciDataAlertComponent,
    HmHeaderComponent
  ],

  exports: [
    MultilangStringWidget,
    WizardWidget,
    AlertModalComponent,
    StrutturaDetailComponent,
    ListaGravidanzeComponent,
    BaseAuthenticatedComponent,
    AutorizzazioniComponent,
    AuthDetailComponent,
    RuoloUtentePipe,
    AssistenzaFaqOperatoriComponent,
    InfoComponent,
    InfoAlertComponent,
    ListaCorsiGruppiUtenteComponent,
    HmHeaderComponent
  ],
})
export class SharedModule {
  constructor(widgetRegistry: WidgetRegistry, toastrService: NbToastrService) {
    widgetRegistry.register('tinymce', TinyMCEWidget);

    widgetRegistry.register('multilang', MultilangStringWidget);
    widgetRegistry.register('multilangrichtext', MultilangRichTextStringWidget);
    widgetRegistry.register('wizard', WizardWidget);

  }

}
